import { generateTranslationKey, toProperCase } from '../../utils/convert.util';
import Translations from '../Translations';
import React, {

} from 'react';
import {
    Card,
    Table,
    Icon,
} from 'semantic-ui-react';
import _ from 'lodash';

import HELPER_FUNCTION_UTILITY from '../../utils/helper';
import ModalSelectProductOption from '../modal/selectproductoption';
import ModalViewDocument from '../modal/viewdocument';
import {hideZeroPrice} from '../../utils/abbth';
import {formatAmountWithCurrency} from '../../utils/currency';

const ProductItem = (props) => {

    const {
        // id,
        name,
        // order,
        // description,
        summaryUrl,
        type,
        productKey,
    } = props.product;

    // console.log('props.coverages', props.coverages);

    const renderSelectedOptions = () => {
        return _.map(_.keysIn(props.coverages), (member) => {
            const coverage = props.coverages[member];
            // get member data
            const m = HELPER_FUNCTION_UTILITY.getMemberFromFamily(
                props.family,
                member,
            );
            // get selected option data
            const sOption = HELPER_FUNCTION_UTILITY.getSelectedCoverageOption(
                coverage.options,
                coverage.selectOption.id,
            );
            // console.log('sOption---->', sOption);
            const priceSign = (sOption.price > 0) ? '-' : (sOption.price < 0) ? '+' : '';
            return (
                <Card.Content key={member}>
                    <Table basic="very" unstackable compact singleLine size="small">
                        <Table.Body>
                            <Table.Row>
                                <Table.Cell>
                                    <b>{toProperCase(m.name)}</b>
                                </Table.Cell>
                                <Table.Cell width={4} textAlign="right">
                                    {!hideZeroPrice(productKey, sOption.price) && <b>{formatAmountWithCurrency(HELPER_FUNCTION_UTILITY.numberWithCommas((sOption.price >= 0) ? sOption.price : sOption.price * -1, props.currencyMinorUnit), props.currency, priceSign)}</b>}
                                    {/* <Icon 
                                        color={(sOption.price >= 0) ? "red" : "blue"}
                                        name={(sOption.price >= 0) ? "minus circle" : "add circle"}
                                        style={{marginLeft: 5}}
                                    /> */}
                                </Table.Cell>
                            </Table.Row>
                            <Table.Row>
                                <Table.Cell colSpan={3}>
                                    {(sOption.isRequiredHdf) && (
                                        <div style={{float: "right", color: "#808191", fontSize: "12px"}}><Translations text="selection.hdf_noti_tooltip1" backup={"HDF Required"} /><Icon name="flag" color="red"/>
                                        </div>
                                    )}
                                    <ModalSelectProductOption 
                                        getAllCoverages={props.getAllCoverages}
                                        coverages={props.coverages}
                                        family={props.family}
                                        productName={sOption.name}
                                        insuranceProductName={name}
                                        productType={type}
                                        coverage={coverage}
                                        member={member}
                                        currencyMinorUnit={props.currencyMinorUnit}
                                        currency={props.currency}
                                        productKey={productKey}
                                        disabled={props.disabled}
                                    />
                                </Table.Cell>
                            </Table.Row>
                        </Table.Body>
                    </Table>
                </Card.Content>
            );
        });
    };

    const calculateTotal = () => {
        let total = 0;
        _.forEach(_.keysIn(props.coverages), (member) => {
            const coverage = props.coverages[member];
            // get selected option data
            const sOption = HELPER_FUNCTION_UTILITY.getSelectedCoverageOption(
                coverage.options,
                coverage.selectOption.id,
            );
            total += sOption.price;
        });
        return total;
        // return HELPER_FUNCTION_UTILITY.numberWithCommas(total);
    };

    const totalAmount = calculateTotal();
    // console.log('totalAmount->', totalAmount);

    return (
        <Card fluid>
            <Card.Content>
                <div style={{float: "right"}}>
                    <ModalViewDocument document={summaryUrl} />
                    {/* <Icon 
                        name="info circle" 
                        color="blue" 
                        onClick={() => console.log('clicked')}
                    /> */}
                </div>
                <Card.Header><Translations text={`insurance_product.${generateTranslationKey(name)}`} backup={name} /></Card.Header>
                {props.product.id && <Translations
                    text={`insurance_product.${props.product.id}_describe`}
                    backup=""
                    render={description => typeof description === 'string' && description.trim()
                        ? <Card.Meta>{description}</Card.Meta>
                        : null}
                />}
            </Card.Content>
            {renderSelectedOptions()}
            <Card.Content>
                <b><Translations text="common.total" backup={"Total"} /></b>
                <div style={{float: "right"}}>
                    <b>{formatAmountWithCurrency(HELPER_FUNCTION_UTILITY.numberWithCommas((totalAmount >= 0) ? totalAmount : totalAmount * -1, props.currencyMinorUnit), props.currency, (totalAmount > 0) ? '-' : (totalAmount < 0) ? '+' : '')}</b>
                    {/* <Icon 
                        color={(totalAmount >= 0) ? "red" : "blue"}
                        name={(totalAmount >= 0) ? "minus circle" : "add circle"}
                        style={{marginLeft: 5}}
                    /> */}
                </div>
            </Card.Content>
        </Card>
    );
};

export default ProductItem;
